import { pdfjs } from "react-pdf";

const EMPTY_IMG =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAHUlEQVR4nGIJ8ihkIAUwkaR6VMOohiGlARAAAP//bOgBLp1D1tIAAAAASUVORK5CYII=";

export const getPdfThumbnails = async (
    url: string | ArrayBuffer,
    maxLength = Number.MAX_SAFE_INTEGER,
    scale = 1,
) => {
    try {
        const doc = await pdfjs.getDocument(url).promise;
        const pages = Array.from(
            { length: Math.min(doc.numPages, maxLength) },
            (_, i) => i + 1,
        );
        const thumbnails = await Promise.all(
            pages.map(async (page, pageIdx) => {
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                if (!context) {
                    throw new Error("Canvas context not found");
                }

                try {
                    const pageObj = await doc.getPage(page);
                    const viewport = pageObj.getViewport({ scale });

                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    await pageObj.render({ canvasContext: context, viewport })
                        .promise;

                    return canvas.toDataURL("image/png");
                } catch (err: unknown) {
                    canvas.width = 64;
                    canvas.height = 64;
                    context.fillStyle = "#f0f0f0";
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.fillStyle = "#000";
                    context.font = "32px Arial";
                    context.textAlign = "center";
                    context.textBaseline = "middle";
                    context.fillText(
                        `${pageIdx + 1}`,
                        canvas.width / 2,
                        canvas.height / 2,
                    );

                    return canvas.toDataURL("image/png");
                }
            }),
        );

        return thumbnails;
    } catch (err: unknown) {
        console.error("Error generating PDF thumbnails:", err);

        return [EMPTY_IMG];
    }
};
